"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVersionsList = exports.fetchFulfillmentConfigurationVersions = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _constants = require("../shared/constants");

var fetchFulfillmentConfigurationVersions = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var accessToken, fulfillmentConfigurationId, environment, queryParams, fulfillmentConfigurationVersionsResponse;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = _ref.accessToken, fulfillmentConfigurationId = _ref.fulfillmentConfigurationId, environment = _ref.environment;
            queryParams = new URLSearchParams();
            queryParams.append('fulfillmentConfigurationIds', "".concat(fulfillmentConfigurationId));
            _context.next = 5;
            return fetch("".concat((0, _constants.FULFILLMENT_CONFIGURATIONS_BASE_URL)(environment), "/v0/versions?").concat(queryParams), {
              method: 'GET',
              headers: {
                Authorization: "Bearer ".concat(accessToken),
                'Content-Type': 'application/json',
                Accept: 'application/json; charset=utf-8'
              }
            });

          case 5:
            fulfillmentConfigurationVersionsResponse = _context.sent;

            if (fulfillmentConfigurationVersionsResponse.ok) {
              _context.next = 8;
              break;
            }

            throw new Error('Error getting fulfillment configuration versions from FCAPI');

          case 8:
            return _context.abrupt("return", fulfillmentConfigurationVersionsResponse.json());

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFulfillmentConfigurationVersions(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchFulfillmentConfigurationVersions = fetchFulfillmentConfigurationVersions;

var getVersionsList = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var accessToken, fulfillmentConfigurationId, environment, _yield$fetchFulfillme, fullFulfillmentConfigurationVersionsList;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accessToken = _ref3.accessToken, fulfillmentConfigurationId = _ref3.fulfillmentConfigurationId, environment = _ref3.environment;
            _context2.next = 3;
            return fetchFulfillmentConfigurationVersions({
              accessToken: accessToken,
              fulfillmentConfigurationId: fulfillmentConfigurationId,
              environment: environment
            });

          case 3:
            _yield$fetchFulfillme = _context2.sent;
            fullFulfillmentConfigurationVersionsList = _yield$fetchFulfillme._embedded.versions;
            return _context2.abrupt("return", fullFulfillmentConfigurationVersionsList.map(function (_ref5) {
              var versionId = _ref5.versionId,
                  versionNumber = _ref5.versionNumber;
              return {
                versionId: versionId,
                versionNumber: versionNumber
              };
            }));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getVersionsList(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getVersionsList = getVersionsList;